import React from "react";
import { Routes, Route } from "react-router-dom";

import UsersListTable from "./UsersListTable";
import User from "./Account";

export default () => (
    <Routes>
        <Route index path="/" element={<UsersListTable />}></Route>
        <Route index path=":userId" element={<User />}></Route>
        <Route index path="create" element={<User />}></Route>
    </Routes>
);
